import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArcButton, ArcStack, ArcToolbar } from '@src/core/ui';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ControllerHeaderProps } from '../../types';

const ControllerHeader: React.FC<ControllerHeaderProps> = ({ onReset }) => {
  const navigate = useNavigate();

  return (
    <ArcStack
      py={2}
      direction='row' 
      alignItems='center' 
      justifyContent='space-between' 
      borderBottom='1px solid'
      borderColor='divider'>
      <ArcToolbar title='Controller Settings' goBack={() => navigate(-1)} />
      <ArcButton.outlined startIcon={<RestartAltIcon sx={{ color: 'white' }} />} onClick={onReset}>
        Reset
      </ArcButton.outlined>
    </ArcStack>
  );
};

export default ControllerHeader;
